<template>
	<div class="notification-popup-container" extension-name="notification">
		<span class="notification-popup-close-button" @click="$emit('close', false)">&times;</span>
		<b class="notification-popup-title">{{title}}</b>
		<p class="notification-popup-message">
			{{ message }}
		</p>
	</div>
</template>

<script>
	export default {
		name: "NotificationPopup",
		props: {
			"title" : {
				type: String
			},
			"message" : {
				type: String
			}
		},
		model: {
			event: "close"
		},
		mounted(){
			const listener = (evt) =>{
				// ignore clicks on itself
				if(evt.target === this.$el || this.$el.contains(evt.target)){
					return;
				}
				this.$emit('close', false);
			};

			document.addEventListener('click', listener);
			this.$once('hook:beforeDestroy', () => {
				document.removeListener("click", listener());
			})
		}
	}
</script>

<style lang="scss">
	.notification-popup-container{
		position: fixed;
		z-index: 1000;
		left: calc(40%);
		top: calc(40%);
		padding: 5px;

		width: 440px;
		height: 141px;
		border-radius: 3px;
		background-color: #ffffff;
		box-shadow: 0 3px 15px 8px hsla(0,0%,51%,1);
		padding-top: 50px;
		padding-left: 40px;

		font-family: Roboto-Regular;

		.notification-popup-title{
			font-size: 15px;
			line-height: 21px;
			color: #474747;
		}

		.notification-popup-close-button{
			float: right;
			margin-top: -50px;
			margin-right: 6px;
		}

		.notification-popup-message{
			margin-top: 10px;
			max-width: 400px;
			word-wrap: break-word;
		}
	}
</style>


// WEBPACK FOOTER //
// src/app/NotificationPopup.vue